import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "sonner";
import Header, { Footer, MobileActionBar } from "@/components/Layout";
import { AuthProvider } from "@/context/AuthContext";

import Home from "@/pages/Home";
import CollectionsIndex from "@/pages/CollectionsIndex";
import CollectionDetail from "@/pages/CollectionDetail";
import About from "@/pages/About";
import Zones from "@/pages/Zones";
import Contact from "@/pages/Contact";
import Privacy from "@/pages/Privacy";
import Soumission from "@/pages/Soumission";
import SoumissionHighLevel from "@/pages/SoumissionHighLevel";
import DevenirCollectionneur from "@/pages/DevenirCollectionneur";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import { JournalIndex, JournalPost } from "@/pages/Journal";

function ScrollToTop() {
    const { pathname } = useLocation();
    useEffect(() => { window.scrollTo({ top: 0, behavior: "instant" }); }, [pathname]);
    return null;
}

function SiteLayout({ children }) {
    return (
        <>
            <Header/>
            <main>{children}</main>
            <Footer/>
            <MobileActionBar/>
        </>
    );
}

function AdminLayout({ children }) {
    return <main>{children}</main>;
}

function App() {
    return (
        <AuthProvider>
            <BrowserRouter>
                <ScrollToTop/>
                <Toaster position="top-right" richColors/>
                <Routes>
                    <Route path="/administration" element={<AdminLayout><AdminLogin/></AdminLayout>}/>
                    <Route path="/administration/tableau" element={<AdminLayout><AdminDashboard/></AdminLayout>}/>
                    <Route path="/" element={<SiteLayout><Home/></SiteLayout>}/>
                    <Route path="/collections" element={<SiteLayout><CollectionsIndex/></SiteLayout>}/>
                    <Route path="/collections/:slug" element={<SiteLayout><CollectionDetail/></SiteLayout>}/>
                    <Route path="/a-propos" element={<SiteLayout><About/></SiteLayout>}/>
                    <Route path="/zones" element={<SiteLayout><Zones/></SiteLayout>}/>
                    <Route path="/contact" element={<SiteLayout><Contact/></SiteLayout>}/>
                    <Route path="/confidentialite" element={<SiteLayout><Privacy/></SiteLayout>}/>
                    <Route path="/soumission" element={<SiteLayout><SoumissionHighLevel/></SiteLayout>}/>
                    <Route path="/soumission-detaillee" element={<SiteLayout><Soumission/></SiteLayout>}/>
                    <Route path="/devenir-collectionneur" element={<SiteLayout><DevenirCollectionneur/></SiteLayout>}/>
                    <Route path="/journal" element={<SiteLayout><JournalIndex/></SiteLayout>}/>
                    <Route path="/journal/:slug" element={<SiteLayout><JournalPost/></SiteLayout>}/>
                    <Route path="*" element={<SiteLayout><Home/></SiteLayout>}/>
                </Routes>
            </BrowserRouter>
        </AuthProvider>
    );
}

export default App;
